import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './css/Login-Register.css';
import logoBold from './assets/logoBold.png';
import { MateriaBasicTextField, MaterialPassword } from './MaterialComponents';

import { setUserSession } from './service/AuthService';

//TODO: move this to an environment variable
const registerUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/register';
const loginrUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/login';

const Register = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isShown, setIsSHown] = useState(false);

    function handleUsernameState(newValue) {
        setUsername(newValue);
    }
    function handlePasswordState(newValue) {
        setPassword(newValue);
    }
    function handleEmailState(newValue) {
        setEmail(newValue);
    }
    function handleNameState(newValue) {
        setName(newValue);
    }

    const navigate = useNavigate()

    const loginHandler = () => {
        navigate('/login');
    }

    const loginRequest = () => {
        // setMessage(null)
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            username: username,
            password: password
        }



        axios.post(loginrUrl, requestBody, requestConfig).then(response => {
            const { user } = response.data;
            const accessToken = response.data.accessToken ?? response.data.token;
            const refreshToken = response.data.refreshToken ?? response.data.refresh_token ?? '';
            if (!user || !accessToken) {
                setMessage('Invalid login response. Please try again.');
                return;
            }
            setUserSession(user, accessToken, refreshToken);
            //console.log('login data response')
            //console.log(response.data.user)
            //console.log(response.data.user.onboardingComplete)
            //TODO: fix bug -- update always shows up
            if(!user.onboardingComplete){
                navigate('/landing-form');
            }
            else{
                navigate('/daily-content'); 
            }
            
        }).catch(error => {
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setMessage(error.response.data.message);
            }
            else{
                setMessage('Sorry the server is down. Please try again later.');

            }
        })
    }

    const submitHandler = (event) => {
        event.preventDefault();
        if(username.trim() === '' || name.trim() === '' || email.trim() === '' || password.trim() === ''){
            setMessage('All fields are required');
            return;
        }
        setMessage(null);

        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            username: username,
            email: email,
            name: name,
            password: password
        }

        axios.post(registerUrl, requestBody, requestConfig).then(response => {
            setMessage('Registration successful. Logging in...')
            // Wait a few seconds for registration message to show up and then send to
            //login page
            setTimeout(() => {
                loginRequest()
            }, 1500);
        }).catch(error => {
            if(error.response.status === 401){
                setMessage(error.response.data.message);
            }
            else{
                setMessage('Sorry the server is down. Please try again later.');
            }
        })
    }

    useEffect(() => {
        document.querySelector('.header').style.display = 'none'
    }, []);

    return (
        // <div>
        //     <form onSubmit = { submitHandler }>
        //         <div className="logo" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '1rem', paddingTop: '7rem'}}>
        //             <img style={{ width: '95%', maxWidth: '335px', maxHeight: '75px' }} src={logoBold} alt="Example" />
        //         </div>
        //         <h4 className="form-title">Welcome Aboard 🚀</h4>
        //         name: <input type="text" value={name} onChange={event => setName(event.target.value)} /> <br />
        //         email: <input type="text" value={email} onChange={event => setEmail(event.target.value)} /> <br />
        //         username: <input type="text" value={username} onChange={event => setUsername(event.target.value)} /> <br />
        //         password: <input type="text" value={password} onChange={event => setPassword(event.target.value)} /> <br />
        //         <input style={{ marginTop: '2rem' }} className="submit-bttn" type="submit" value="Register" />
        //     </form>
        //     <div className="button-container-login-register">
        //         <button className=" button login button-login-register" onClick={loginHandler}>Login</button>
        //         <button className="button register button-login-register">Register</button>
        //     </div>
        //     {message && <p className="message"> { message } </p>}
        // </div>
        <div style={{ marginLeft: '2rem', marginRight: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: '2rem'}}> 
            <div className="logo" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '1rem', paddingTop: '7rem'}}>
                <img style={{ width: '95%', maxWidth: '415px', marginBottom: '1rem'}} src={logoBold} alt="Example" />
            </div>
            {/* <form onSubmit = { submitHandler }> */}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    <h4 className="form-title" style={{ textAlign: 'center' }}>Welcome Aboard 🚀</h4>
                    <div className="relapseQuestion">name:</div>
                    <MateriaBasicTextField handleChange={handleNameState}/>
                    <div className="relapseQuestion">email:</div>
                    <MateriaBasicTextField handleChange={handleEmailState} />
                    <div className="relapseQuestion">username:</div>
                    <MateriaBasicTextField handleChange={handleUsernameState}/>
                    <div className="relapseQuestion">password:</div>
                    <MaterialPassword handleChange={handlePasswordState} />
                    {/* <MateriaBasicTextField type={isShown ? "text" : "password"} handleChange={handlePasswordState} /> */}
                    {/* username: <input type="text" value={username} onChange={event => setUsername(event.target.value)} /> <br /> */}
                    {/* password: <input type={isShown ? "text" : "password"} className="input" value={password} onChange={event => setPassword(event.target.value)} /> <br /> */}
                    {/* <input style={{ marginTop: '2rem' }} className="submit-bttn" type="submit" value="Login" /> */}
                    {message && <p className="message"> { message } </p>}
                    <button type="submit" className="homeBttn" style={{ marginTop: '1.5rem', width: '310px' }} onClick={ submitHandler }>Register</button>
                </div>
            {/* </form> */}
            <button className="homeBttn" style={{ marginTop: '1rem', width: '310px', marginBottom: '1rem'}} onClick={ loginHandler }>Login</button>
            {/* <div className="button-container-login-register">
                <button className="login button-login-register">Login</button>
                <button className="register button-login-register" onClick={registerHandler}>Register</button>
            </div> */}
        </div>
    )
}


export default Register;